import { c as i, j as r } from "./createRuntimeFn-62c9670f.esm-CXdMsbWY.js";
import { a as m } from "./import-_PjWeMm4.js";
/* empty css                              */
var n = "_1w853300", l = i({ defaultClassName: "_1w853302 _1w853301", variantClassNames: { size: { normal: "_1w853303", small: "_1w853304" } }, defaultVariants: {}, compoundVariants: [] });
const f = ({
  size: e = "normal",
  onChange: a,
  isSelected: s,
  disabled: t
}) => {
  const o = {
    ...a ? { onChange: a } : {},
    ...typeof s < "u" ? { isSelected: s } : {}
  };
  return /* @__PURE__ */ r.jsx(
    m,
    {
      className: n,
      isDisabled: t || !1,
      ...o,
      children: /* @__PURE__ */ r.jsx("div", { className: l({ size: e }) })
    }
  );
};
export {
  f as S
};
//# sourceMappingURL=Switch-BoUWWFW5.js.map
